document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.full-header-navigation > ul > li');

    menuItems.forEach(item => {
        const toggle = item.querySelector('.submenu-toggle');

        if (toggle) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();

                const isActive = item.classList.contains('active');

                menuItems.forEach(mi => mi.classList.remove('active'));

                if (!isActive) {
                    item.classList.add('active');
                }
            });
        }
    });

    const currentPath = window.location.pathname;

    document.querySelectorAll('.full-header-navigation a').forEach(link => {
        const href = link.getAttribute('href');
        if (!href || href === '#') return;

        if (href === currentPath) {
            link.classList.add('active');

            const parentLi = link.closest('.full-header-navigation-children')?.closest('li');
            if (parentLi) {
                parentLi.classList.add('active');
            }
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            menuItems.forEach(item => item.classList.remove('active'));
        }
    });

    document.addEventListener('click', function (e) {
        if (!e.target.closest('.full-header-navigation')) {
            menuItems.forEach(item => item.classList.remove('active'));
        }
    });
});
